module.exports = __webpack_public_path__ + "static/5-7ff984d6dc88f05be5e4c05a8f32a811.jpg";